import React from 'react';
import ApexNavbar from '../components/apex/ApexNavbar';
import ApexHero from '../components/apex/ApexHero';
import ApexStats from '../components/apex/ApexStats';
import ApexWeGetIt from '../components/apex/ApexWeGetIt';
import ApexProblemSolution from '../components/apex/ApexProblemSolution';
import ApexComparison from '../components/apex/ApexComparison';
import ApexFullService from '../components/apex/ApexFullService';
import ApexCalculator from '../components/apex/ApexCalculator';
import ApexHowItWorks from '../components/apex/ApexHowItWorks';
import ApexTestimonials from '../components/apex/ApexTestimonials';
import ApexCTA from '../components/apex/ApexCTA';
import ApexFooter from '../components/apex/ApexFooter';

const Homepage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <ApexNavbar />
      <main>
        <ApexHero />
        <ApexStats />
        <ApexWeGetIt />
        <ApexProblemSolution />
        <ApexComparison />
        <ApexFullService />
        <ApexHowItWorks />
        <ApexCalculator />
        <ApexTestimonials />
        <ApexCTA />
      </main>
      <ApexFooter />
    </div>
  );
};

export default Homepage;
